// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-application h1,.v-application h2,.v-application h3,.v-application h4,.v-application h5{font-family:Helvetica,sans-serif}.v-application h1{font-size:38px;line-height:40px}.v-application .headline-light{font-family:Adieu Light}.v-btn{font-family:Helvetica!important}.v-btn .v-btn__content{font-size:11px}.authed-screen .col{text-align:center}.authed-screen a{display:block;color:inherit}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
